// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for UPC_E_to_A

function ccd_UPC_E_to_A(strECode) {
  var chrType,
    strACode = "";

  chrType = strECode.charAt(6);
  strACode = strECode.charAt(0);

  if (chrType >= "0" && chrType <= "2")
    strACode +=
      strECode.substr(1, 2) + chrType + "0000" + strECode.substr(3, 3);
  else if (chrType == "3")
    strACode += strECode.substr(1, 3) + "00000" + strECode.substr(4, 2);
  else if (chrType == "4")
    strACode += strECode.substr(1, 4) + "00000" + strECode.charAt(5);
  else strACode += strECode.substr(1, 5) + "0000" + chrType;

  return strACode;
}
export default ccd_UPC_E_to_A;
